import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async get() {
        try{            
            const response = await axios.get(`WorkDays`,
            {
                headers: {
                    'page_key': pageKeys.workdays 
                }
            })                                                           
            return response
        }catch (error){
            throw error
        }
    },
    async update(data) {
        try{            
            const response = await axios.post(`WorkDays`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.workdays 
                }
            })            
            return response
        }catch (error){
            throw error
        }
    },
}